export enum TemplateAssignedRole {
  MENTOR = 'mentor',
  MENTEE = 'mentee',
}

export type MentoringProgramActionItemTemplate = {
  id: number;
  description: string;
  assignedRole: TemplateAssignedRole;
  required: boolean;
  propagated: boolean;
};
